import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c1f8293&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c1f8293&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f8293",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1f8293')) {
      api.createRecord('4c1f8293', component.options)
    } else {
      api.reload('4c1f8293', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c1f8293&scoped=true", function () {
      api.rerender('4c1f8293', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSystem/userInfo/components/dynamicPage/index.vue"
export default component.exports